import React from 'react';
import { Map } from 'immutable';

const MESSAGES = {
    'Event:suspended': 'This event is suspended',
    'Market:suspended': 'This market is suspended',
    'Selection:suspended': 'This selection is suspended',
    'suspended': 'Something is suspended',

    'Event:not-found': 'This event doesn\'t exists',
    'Market:not-found': 'This market doesn\'t exists',
    'Selection:not-found': 'This selection doesn\'t exists',

    'Selection:increased': 'Price of this selection has increased',
    'Selection:decreased': 'Price of this selection has decreased',

    'Selection:related': 'There are related selections in bet',
    'Selection:ValidationCodes.Related': 'There are unaccepted related selections in bet',

    'Account:suspended': 'Your account is suspended',
    'Account:playbreak': 'Your account has playbreak on',
    'Account:Playbreak': 'Your account has playbreak on',

    'Bet:unacceptable': 'Unacceptable type of bet',

    'stakePerLine:maximum': 'You reached maximum bet',

    'stakePerLine:minimum': 'Bet need at least 1.00 of stake',

    'SettlementCode:unacceptable': 'Can\'t settle bet - something goes wrong',
    'Bet:eachWay:unacceptable': 'This bet has no each way terms',
    'eachWay:not-found': 'This bet has no each way terms',

    'Market:forecastsOffered:bet-type-not-allowed': 'Forecasts are not allowed for this market',
    'Market:tricastsOffered:bet-type-not-allowed': 'Tricasts are not allowed for this market',
    'Market:bet-type-not-allowed': 'Bet type is not allowed',
    'Market:settlement-blocked': 'Market has blocked settlements',
    'paymentMethod:declined': 'Deposit declined (101)',
    'paymentMethod:referral-a': 'Deposit referred',
    'paymentMethod:referral-b': 'Deposit referred',
    'paymentMethod:comms-error': 'Deposit declined (205)',

    'missing': 'Something is missing'
};

export default function getErrorMessage(error) {
    if (typeof error === 'string') {
        return error;
    }

    let code = error.get('code');
    let semi = error.get('field') + ':' + code;
    let semi2 = error.get('resource') + ':' + code;
    let full = error.get('resource') + ':' + semi;

    let message = MESSAGES[full] || MESSAGES[semi2] || MESSAGES[semi] || MESSAGES[code] || full;

    return typeof message === 'function' ? message(error) : message;
}

export function mapErrors(errors) {
    let errorsList = Map();


    if (errors instanceof Map) {
        return errors;
    }

    if (!errors || !errors.size) {
        return errorsList;
    }

    errors.forEach(error => {
        errorsList = errorsList.set(error.get('resource') + ':' + error.get('code'), error);
    });

    return errorsList;
}


export function listMappedErrors(errors, definitions = {}) {
    errors = errors
        .map((details, code) => {
            return {
                code,
                message: definitions[code] ? definitions[code](details) : getErrorMessage(details)
            };
        })
        .toList();

    return errors
        .filter(({ message }, idx) => errors.findIndex(e => e.message === message) === idx)
        .map(({ message, code }) => {
            if (typeof message === 'string') {
                return <li key={ code }>{ message }</li>;
            }

            return message;
        })
        .toArray();
}
